import React from 'react'
import {Grid} from '@chakra-ui/react'

import {UserCardSkeleton} from '../components/UserCard'

export function UserProfileFansSkeleton() {
  return (
    <Grid gap={4} templateColumns="repeat(3, 1fr)">
      {Array.from(Array(6).keys()).map((i) => (
        <UserCardSkeleton key={i} />
      ))}
    </Grid>
  )
}
